'use client';

interface CropOverlayProps {
  x: number;
  y: number;
  width: number;
  height: number;
  displayScale: number;
  padding?: number;
}

export function CropOverlay({
  x,
  y,
  width,
  height,
  displayScale,
  padding = 16,
}: CropOverlayProps) {
  return (
    <div
      className="absolute inset-0 pointer-events-none"
      style={{
        boxShadow: `0 0 0 9999px rgba(0, 0, 0, 0.5)`,
        left: x * displayScale + padding,
        top: y * displayScale + padding,
        width: width * displayScale,
        height: height * displayScale,
      }}
    />
  );
}
